<header
  id="BUYER_PAGES.HEADER"
  class="page-header"
  [mmTestId]="'BUYER_PAGES.HEADER'"
>
  <div class="page-header page-header__topline">
    <app-generic-header-topline [user]="user$ | async"></app-generic-header-topline>
  </div>
    <app-secondary-header *ngIf="!isUserBlocked && showSecondaryHeader"
                          [isDesktop]="isDesktop"
                          [isSearchOnFocus]="(isSearchInputFocused$ | async)"
                          [user]="(user$ | async)">
    </app-secondary-header>
</header>
<div
  [mmTestTarget]="'overlay'"
  [mmTestState]="(isSuggestionsListVisible$ | async) ? 'active' : 'inactive'"
  class="overlay"
  [ngClass]="{'overlay--active': (isSuggestionsListVisible$ | async) || (!isDesktop && (isSearchInputFocused$ | async))}"
></div>
<router-outlet name="footer"></router-outlet>
